// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  ADMIN: '/admin',
};

const WORKSPACE = `${ROOTS.ADMIN}/workspace`;

// ----------------------------------------------------------------------

export const paths = {
  // LOGIN
  login: '/login',
  // ADMIN
  admin: {
    root: ROOTS.ADMIN,
    workspace: {
      root: `${WORKSPACE}`,
      new: `${WORKSPACE}/new`,
      details: (id) => `${WORKSPACE}/${id}`,
      audiences: (id) => `${WORKSPACE}/${id}/audiences`,
      people: (id) => `${WORKSPACE}/${id}/people`,
      person: (id, personId) => `${WORKSPACE}/${id}/people/${personId}`,
      mailboxes: (id) => `${WORKSPACE}/${id}/mailboxes`,
      flows: (id) => `${WORKSPACE}/${id}/flows`,
      flowCreate: (id) => `${WORKSPACE}/${id}/flow/create`,
      flowEdit: (id, flowId) => `${WORKSPACE}/${id}/flow/${flowId}`,
      mails: (id, tab = 'replied') => `${WORKSPACE}/${id}/mails?tab=${tab}`,
      mail: (id, tab, mailId) => `${WORKSPACE}/${id}/mails?tab=${tab}&id=${mailId}`,
      aiSettings: (id) => `${WORKSPACE}/${id}/ai/settings`,
      settings: (id) => `${WORKSPACE}/${id}/settings`,
      flowPeople: (id, flowId) => `${WORKSPACE}/${id}/flow/${flowId}/people`,
      linkedin: (id) => `${WORKSPACE}/${id}/linkedin`,
      engage: (id) => `${WORKSPACE}/${id}/engage`,
      approvals: (id) => `${WORKSPACE}/${id}/approvals`,
      queue: (id) => `${WORKSPACE}/${id}/queue`,
      tasks: (id) => `${WORKSPACE}/${id}/tasks`,
      linkedinInbox: (id) => `${WORKSPACE}/${id}/linkedin-inbox`,
      linkedinAssistant: (id) => `${WORKSPACE}/${id}/linkedin-assistant`,
      doNotContact: (id) => `${WORKSPACE}/${id}/do-not-contact`,
    },
  },
};
